import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { markWebsiteNotificationAsRead } from '~/modules/notifications/api/mark-website-notifications-as-read.server';

export const MARK_WEBSITE_NOTIFICATION_AS_READ_API_ROUTE =
    '/remix-api/notifications/mark-as-read';

const schema = zfd.formData({
    ID: zfd.numeric(z.number().int().positive()),
});

/**
 * Mark a single website notification as read.
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const parsed = schema.safeParse(await request.formData());
    if (!parsed.success) {
        return routerData({ ok: false as const }, { status: 400 });
    }

    const ok = await markWebsiteNotificationAsRead({
        context,
        notificationId: parsed.data.ID,
    });

    if (!ok) {
        return routerData({ ok: false as const }, { status: 500 });
    }

    return { ok: true as const };
};
